/* =====================================================================
   Swift Ink: smooth loading.
   Lazy-loaded photos fade in as they arrive instead of popping in. Only
   photos still loading get the fade, so cached ones show straight away, and
   it also covers photos added later (shop filters, the cart, rails).
   Lazy photos are also started about 1.5 screens before they scroll into
   view. Browsers' own lazy loading (Safari / TikTok's in-app browser
   especially) waits until they are nearly on screen, so they arrived late.
   The page-to-page fade and link prefetching live in layout/theme.liquid.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__siSmooth) return;
  window.__siSmooth = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SCOPE = 'main, #SiCart';

  function loaded(img) {
    img.classList.add('is-loaded');
  }

  var ahead = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      ahead.unobserve(entries[i].target);
      entries[i].target.loading = 'eager';
    }
  }, { rootMargin: '0px 0px 150% 0px' }) : null;

  function prep(img) {
    if (img.__siFade) return;
    img.__siFade = true;
    if (ahead && img.loading === 'lazy' && !img.complete) ahead.observe(img);
    /* Only lazy photos: anything loading straight away (the hero, the first
       row of the shop) must never be held back by a fade. */
    if (img.loading !== 'lazy' || !img.closest(SCOPE)) return;
    if (img.complete && img.naturalWidth) return;
    img.classList.add('si-img-fade');
    img.addEventListener('load', function () { loaded(img); }, { once: true });
    img.addEventListener('error', function () { loaded(img); }, { once: true });
  }

  function scan(root) {
    if (root.tagName === 'IMG') {
      prep(root);
      return;
    }
    if (root.querySelectorAll) root.querySelectorAll('img').forEach(prep);
  }

  function boot() {
    scan(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
